import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {CommonService} from 'src/app/core/services/common.service';
import {DocumentService} from 'src/app/core/services/document.service';
import {Message} from 'src/app/core/class/message';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute} from '@angular/router';
import {NotificationService} from 'src/app/core/services/notification.service';
import {EnterpriseService} from 'src/app/core/services/enterprise.service';
import {WarningSmsContractService} from 'src/app/core/services/warning-sms-contract.service';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import {EnumContractStatus} from 'src/app/core/constants/contract';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {MatDialog} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AutoDocumentTypeParentService} from 'src/app/core/services/auto-document-type-parent.service';
import {AutoDocumentTypeParentFilterBynameService} from 'src/app/core/services/auto-document-type-parent-filter-byname.service';
import {CustomerService} from 'src/app/core/services/customer.service';
import {BranchService} from 'src/app/core/services/branch.service';
import {AutoDocumentTypeService} from 'src/app/core/services/auto-document-type.service';
import {AutoUserService} from 'src/app/core/services/auto-user.service';
import {DocumentTypeService} from 'src/app/core/services/document-type.service';
import {NzConfigService} from 'ng-zorro-antd/core';
import {NzModalService} from 'ng-zorro-antd/modal';
import {MatExpansionPanel} from '@angular/material/expansion';
import {NzInputDirective} from 'ng-zorro-antd/input';
// tslint:disable-next-line:max-line-length
import {EnterpriseEntity} from 'src/app/core/class/enterpriseEntity';
import {UserEntity} from 'src/app/core/class/UserEntity';
import {CreateContractService} from 'src/app/core/services/create-contract.service';


@Component({
  selector: 'app-fill-general-contract-info',
  templateUrl: './fill-general-contract-info.component.html',
  styleUrls: ['./fill-general-contract-info.component.scss']
})
export class FillGeneralContractInfoComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() maxSize: number = 10485760
  constructor(
    private el: ElementRef,
    public commonService: CommonService,
    private customerService: CustomerService,
    private dialog: MatDialog,
    private documentService: DocumentService,
    public notificationService: NotificationService,
    public message: Message,
    private toastr: ToastrService,
    private branchService: BranchService,
    public autoDocumentTypeData: AutoDocumentTypeService,
    public autoDocumentTypeParentData: AutoDocumentTypeParentService,
    public autoUserService: AutoUserService,
    private documentTypeService: DocumentTypeService,
    private warningSmsContractService: WarningSmsContractService,
    public autoDocumentTypeParentFilterBynameData: AutoDocumentTypeParentFilterBynameService,
    private route: ActivatedRoute,
    private enterpriseService: EnterpriseService,
    private nzConfigService: NzConfigService,
    private formBuilder: FormBuilder,
    private modalService: NzModalService,
    private createContractService: CreateContractService,
  ) {
    super(commonService, message);
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.subscribeIsInvalidSetPartyFlow = new BehaviorSubject<boolean>(false);

  }

  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;

  // -------------------------------***Start - Declare available***-------------------------------//
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();


  /**
   * Change template observe.
   */

  /**
   * Change data obsever.
   */

  /**
   * Validate panel data is success.
   */
  public isPanelSuccess = new Subject();

  templateDocument: any;

  // Fill for viewpdf
  pdfSrc = '';

  // original upload file for editing.
  originalFileUpload: string;

  // Value of selected
  valueSelect = null;

  // List attachments

  // Whether the form change or not
  isFormChanging = false;

  // Selected parent documentType
  // Parent document data, ex: contacter phone, contacter email...

  // Selected model value for autocomplete
  defaultSelectedCustomer = {id: '', name: ''};
  selectedCustomer: { id: string, name: string };

  selectedEnterprise: {
    id: string;
    name: string;
    email: string;
    mstcmnd: number;
    phone: number;
    status: number;
    isCreatedSide: boolean;
    enterpriseId: string;
    customerId: string,
    taxCode: string
  };

  selectedUser: {
    id: string;
    enterpriseId: number;
    fullName: string;
    email: string;
    phone: string;
    taxCode: string;
    isSameEntepriseCurrentLogin: number;
  };

  // Subscribe to form changing
  formChangesSubscription: Subscription;

  shareDocumentSubscription: Subscription;
  firstEditLoaded = true;

  checkExpiredReq = true;

  isChangeParentDocument = false;


  dialogRefFileAttachComponent: any;

  readonly CUSTOMER_PHONE_CHANGE = 'CUSTOMER_PHONE_CHANGE';
  readonly CUSTOMER_EMAIL_CHANGE = 'CUSTOMER_EMAIL_CHANGE';

  bindDataFromAddComponent = false;

  // enum
  enumContractStatus = EnumContractStatus;


  displayedColumnsEnterprise: string[] = ['order', 'name', 'email', 'phone', 'action'];
  displayedColumnsUser: string[] = ['index', 'member', 'perform', 'action'];
  ENTERPRISE_DATA: EnterpriseEntity[] = [];
  USER_DATA: UserEntity[] = [];

  recordSelectedUser: UserEntity;


  // show/hide
  private subscribeIsInvalidSetPartyFlow: BehaviorSubject<boolean>;

  isValidUserAlreadyExists = false;
  isRequiredUserInput = true;


  // TRY: APPLY NZ-TABLE FOR CREATE DOCUMENT
  indexNzTable = 0;
  editId: string | null = null;
  isInvalidSetPartyFlow = false;
  isInvalidPartyOrder = false;


  @ViewChild('autocompleteInput', {static: false}) autocompleteInput: ElementRef;
  @ViewChild(NzInputDirective, {static: false, read: ElementRef}) inputElement: ElementRef;
  @Input() warningContractQuantity: boolean;


  listAttachFile = [];
  newUploadContractAttachments = [];


  // -------------------------------***The End - Declare available***-------------------------------//
  enterpriseId: string;
  expanded = [];
  expandedUser = [];
  mainTitle = '';

  registerForm: FormGroup = this.formBuilder.group({
    signPage: ['', {
      validators: [Validators.min(1)],
      updateOn: 'blur'
    }]
  });


  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  ngOnInit() {

  }


  isUpdateDocument() {
    const pathname = window.location.pathname;
    if (pathname.search('home-enterprise/update-document') !== -1) {
      return true;
    }
    return false;
  }

  /**
   * Initial the data
   */


  /**
   * after initialize success.
   */
  ngAfterViewInit() {
  }


  /**
   * before destroy the component
   */
  ngOnDestroy() {
    // this.shareDocumentSubscription.unsubscribe();
  }




  /**
   * Get customer by id
   * @param id the customer id.
   * @param isEdit edit or not.
   */


  /**
   * Get attachment of customer
   */
  // public getAttachmentOfCustomer(id) {
  //   this.customerService.getAttachOfCustomer(id).subscribe(rs => {
  //     if (rs != null && rs.data != null) {
  //       this.setAttachFile(rs.data);
  //     }
  //   });
  // }

  /**
   * On change autocomplete when select document type
   */






  // public onChangeAutoCompletedCustomer() {
  //   if (!this.firstEditLoaded) {
  //     // Reset list contractAttachments
  //     this.document.contractAttachments = [];
  //     if (this.route.snapshot.queryParams.flagCopy) {
  //       this.document.newUploadContractAttachments = [];
  //     }
  //   }
  //
  //   if (this.selectedCustomer === null || this.selectedCustomer === undefined) {
  //     this.customer.customerName = '';
  //     this.document.customerId = '';
  //   } else {
  //
  //     this.document.customerId = this.selectedCustomer.id;
  //     if (!this.firstEditLoaded) {
  //       this.setFormChanging(true);
  //     }
  //
  //     if (!this.firstEditLoaded) {
  //       this.setFormChanging(true);
  //       this.getCustomerById(this.selectedCustomer.id);
  //       this.getAttachmentOfCustomer(this.selectedCustomer.id);
  //       this.document.contractAttachments = [];
  //     }
  //   }
  // }

  // On change when auto completed filter will get user for MST/CMND
  // onChangeAutoCompletedUser() {
  //   this.setFormChanging(true);
  //   if (this.selectedUser) {
  //     // this.recordSelectedUser = {
  //     //   order: (this.USER_DATA.length + 1),
  //     //   userId: this.selectedUser.id,
  //     //   enterpriseId: this.enterpriseIdParent !== null && this.enterpriseIdParent.length > 0 ? this.enterpriseIdParent[0].enterpriseId : this.defaultEnterprises.enterpriseId,
  //     //   userName: this.selectedUser.fullName,
  //     //   userEmail: this.selectedUser.email,
  //     //   role: this.valueSelectedPerform == true ? this.roleUser.APPROVE : this.roleUser.SIGN,
  //     //   email: this.selectedUser.email,
  //     //   name: this.selectedUser.fullName,
  //     //   phone: this.selectedUser.phone,
  //     //   taxCode: this.selectedUser.taxCode,
  //     // }
  //
  //     // validate check duplicate user.
  //     if (this.USER_DATA.filter(x => x.userId === this.selectedUser.id).length >= 1) {
  //       this.toastr.warning(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate'), this.selectedUser.fullName));
  //       return;
  //     } else {
  //       // Nếu đã tồn tại một người dùng là Ký và lại chọn thực hiện là Ký.
  //       // if (this.USER_DATA.filter(x => x.role === this.roleUser.SIGN).length >= 1 && this.valueSelectedPerform == false) {
  //       //   this.toastr.warning(this.commonService.format(this.message.getMessage('messages.add_user_perform_sign_apostrophe_duplicate'), this.selectedUser.fullName));
  //
  //       //   //Lấy record chứa phương thức Ký
  //       //   this.RECORD_USER_PERFORM_SIGN = this.USER_DATA.filter(x => x.role === this.roleUser.SIGN);
  //       //   return;
  //       // } else {
  //       //   //Nếu chưa có phương thức Ký thì add bình thường.
  //       //   this.USER_DATA.push(this.recordSelectedUser);
  //       //   this.dataSourceUser = new MatTableDataSource(this.USER_DATA);
  //       // }
  //     }
  //     this.validateErrorSetUser();
  //   }
  // }


  // Xóa người dùng trong bảng User
  // onClickDeleteElementRecordUser(dataRow: any) {
  //   this.setFormChanging(true);
  //   if (dataRow !== null && dataRow !== undefined) {
  //     const index: number = this.USER_DATA.indexOf(dataRow);
  //     if (index !== -1) {
  //       this.USER_DATA.splice(index, 1);
  //     }
  //     this.USER_DATA = this.USER_DATA.map((item, index) => {
  //       return {
  //         ...item,
  //         order: index + 1
  //       }
  //     })
  //     this.dataSourceUser = new MatTableDataSource(this.USER_DATA);
  //     this.validateErrorSetUser();
  //   }
  // }

  public onChangeCustomerInforElementOnTableEnterprise(type: string) {
    const valid = 'VALID';
    // if (type === this.CUSTOMER_EMAIL_CHANGE_ELEMENT_ROW && this.ngForm.form.controls['email'].status === valid) {
    //   this.onChangePanelData.next({
    //     customerInfo: {
    //       customerContacterEmail: this.customer.customerEmail
    //     }
    //   });
    // }
  }

//   /**
//    * Open dialog add customer
//    * old version of Hitachi
//
//    public openAddCustomer() {
//   this.customerDialog = this.dialog.open(AddCustomerDialogComponent, {
//     width: '70%',
//     data: true
//   });
//
//   this.customerDialog.componentInstance.createSuccess.asObservable().subscribe(() => {
//     this.selectedCustomer = null;
//     this.autoComplete.resetForm();
//     this.getCustomerById(this.documentService.getCustomerId(), false, (customer) => {
//       this.selectCustomer(customer);
//       this.autoComplete.formControl.setValue(this.selectedCustomer);
//     });
//
//     this.getAttachmentOfCustomer(this.documentService.getCustomerId());
//   });
// }
//    */
//
//   private selectCustomer(customer) {
//     this.selectedCustomer = {
//       id: customer.customerId,
//       name: customer.customerName
//     };
//   }


  // public onChangeCustomerInfor(type: string) {
  //   const valid = 'VALID';
  //   if (type === this.CUSTOMER_EMAIL_CHANGE && this.ngForm.form.controls.email.status === valid) {
  //     this.onChangePanelData.next({
  //       customerInfo: {
  //         customerContacterEmail: this.customer.customerEmail
  //       }
  //     });
  //   } else if (type === this.CUSTOMER_PHONE_CHANGE && this.ngForm.form.controls.phone.status === valid) {
  //     this.onChangePanelData.next({
  //       customerInfo: {
  //         customerContacterPhone: this.customer.customerPhone
  //       }
  //     });
  //   }
  // }


//   Lấy thông tin doanh nghiệp khi đăng nhập vào
//
//    getDefaultEnterprises() {
//   // tslint:disable-next-line:jsdoc-format
//   const enterpriseId = localStorage.getItem('enterpriseId');
//   this.enterpriseService.getEnterpriseByID(enterpriseId).subscribe(rs => {
//     if (rs && rs.data) {
//       this.defaultEnterprises.order = 1;
//       this.defaultEnterprises.enterpriseId = rs.data.id || null;
//       this.defaultEnterprises.enterpriseName = rs.data.name || '';
//       this.defaultEnterprises.name = rs.data.name || '';
//       this.defaultEnterprises.email = rs.data.email || '';
//       this.defaultEnterprises.phone = rs.data.phone || null;
//       this.defaultEnterprises.isCreatedSide = true;
//       this.defaultEnterprises.status = rs.data.status || null;
//       this.defaultEnterprises.taxCode;
//       //=> push element first to array nếu nó không phải đang edit
//       if (!this.document.id) {
//         this.ENTERPRISE_DATA.push(this.defaultEnterprises);
//         this.RECORD_PARTY_SIGN = [
//           {
//             enterpriseId: rs.data.id || '',
//             order: 1,
//             email: rs.data.email || '',
//             enterpriseName: '',
//             phone: rs.data.phone || '',
//             status: this.enumContractEnterpriseStatus.NO_PROCESS,
//             isCreatedSide: true,
//             customerId: '',
//             name: rs.data.name || '',
//             taxCode: this.defaultEnterprises.taxCode
//           }
//         ];
//       }
//       this.dataSourceEnterprise = new MatTableDataSource(this.ENTERPRISE_DATA);
//     }
//   }, (error) => console.log(error))
// }
  // * Lấy danh sách Người dùng sẽ ký/Duyệt Hợp đồng && Lấy danh sách các bên chủ thể sẽ Ký Hợp đồng


  // hiển thị title của screen khi thực hiện các action tương ứng.
  getTxtTitle() {
    switch (this.route.snapshot.url[0].path) {
      case 'view-document':
        this.mainTitle = this.message.getMessage('title.document_view');
        break;
      case 'update-document':
        this.mainTitle = this.message.getMessage('title.update_document');
        break;
      case 'add-document':
        this.mainTitle = this.message.getMessage('title.create_contract');
        break;
      default:
        break;
    }
  }

  public onSubmit() {
    // this.validateSuccess = true;
    // // Check whether upload or select file from template
    // if (this.valueSelect !== 0 && this.valueSelect !== 1) {
    //   this.toastr.error(this.message.getMessage('validation.doc_craete_by'));
    // } else {
    //   // Check valid user and valid party
    //   if (!this.validateErrorSetUser() && !this.validateSetupParty()) {
    //     this.standardizedData();
    //     this.isPanelSuccess.next({
    //       ...this.document,
    //       enterpriseSign: this.RECORD_PARTY_SIGN,
    //       userSign: this.RECORD_USER_PERFORM_SIGN.filter(r => r.order !== 0)
    //     });
    //   } else {
    //     // this.toastr.error(this.message.getMessage('messages.error_establish_party_or_user'));
    //     this.panels.forEach((x, index) => {
    //       if (index === 2 && (this.isInvalidSetPartyFlow || this.isEmailPhoneInvalid)) {
    //         x.open();
    //       }
    //       if (index === 3 && this.isValidNoUserExist) {
    //         x.open();
    //       }
    //     });
    //
    //     setTimeout(() => {
    //       if (this.isInvalidSetPartyFlow || this.isEmailPhoneInvalid) {
    //         document.getElementById('inputParty').focus();
    //       } else {
    //         document.getElementById('inputUser').focus();
    //       }
    //     }, 500);
    //   }
    // }
  }
}
